// Lanka Express Logistics - Mock Data (sourced from lankaexpresslogi.com & facebook.com/LankaExpressEU)

export const company = {
  name: 'Lanka Express Logistics',
  tagline: 'we deliver happiness',
  subTagline: 'Elevating joy, One delivery at a time. Your satisfaction, Our priority. A one-stop-shop for logistic solutions.',
  headOfficeAddress: 'Via Della Republica, 49 20090 Cesano Boscone Lombardy Italy.',
  phone: '+39 327 989 0838',
  phoneRaw: '+393279890838',
  email: 'contact@lankaexpresslogi.com',
  facebookPage: 'LankaExpressEU',
  yearsExperience: 11,
  countries: 50,
  customers: 25000,
};

export const socials = [
  { name: 'Facebook', url: 'https://www.facebook.com/LankaExpressEU', icon: 'facebook' },
  { name: 'Instagram', url: 'https://www.instagram.com/lanka_express.europe', icon: 'instagram' },
  { name: 'TikTok', url: 'https://www.tiktok.com/@lankaexpress_official', icon: 'tiktok' },
];

export const heroCards = [
  { title: 'Air & Sea Freight', desc: 'We handle personal and commercial shipments across the globe.', icon: 'Plane' },
  { title: 'Road Transportation', desc: 'Integrated road freight across 50+ countries with a full modern fleet.', icon: 'Truck' },
  { title: '3PL Services', desc: 'Third-party logistics partner — warehousing, inventory and fulfilment.', icon: 'Warehouse' },
];

export const services = [
  { title: 'Air Freight', icon: 'Plane', desc: 'Specialized air cargo services for personal effects and commercial cargo — fast, safe, global.' },
  { title: 'Sea Freight', icon: 'Ship', desc: 'Your trusted partner for commercial sea cargo, bulk, project & container shipments worldwide.' },
  { title: 'Road Transportation', icon: 'Truck', desc: 'Integrated transport from all ports via road and rail with a fleet across Sri Lanka and Europe.' },
  { title: 'International Warehousing', icon: 'Warehouse', desc: 'Strategic warehousing solutions giving your business a true global operational advantage.' },
  { title: 'Bonded Warehousing', icon: 'ShieldCheck', desc: 'Reliable, efficient bonded warehousing for businesses engaged in international trade.' },
  { title: 'Cargo Insurance', icon: 'ShieldAlert', desc: 'Comprehensive cargo insurance for total peace of mind on every shipment.' },
  { title: 'Bonded Trucks', icon: 'TruckIcon', desc: 'Dedicated bonded trucks catering to specialized international trade requirements.' },
  { title: 'Custom Clearances', icon: 'FileCheck', desc: 'Comprehensive custom clearance services tailored to your business needs.' },
  { title: 'UPB Operation', icon: 'PackageOpen', desc: 'Top-notch UPB (Unaccompanied Personal Baggage) operational services.' },
];

export const industries = [
  { name: 'Automotive', icon: 'Car' },
  { name: 'Technology', icon: 'Cpu' },
  { name: 'Healthcare', icon: 'HeartPulse' },
  { name: 'Renewable Energy', icon: 'Leaf' },
  { name: 'Industrial', icon: 'Factory' },
  { name: 'Retail', icon: 'ShoppingBag' },
];

export const stats = [
  { label: 'Years in the Industry', value: 11, suffix: '+' },
  { label: 'Countries Worldwide', value: 50, suffix: '+' },
  { label: 'Customers Worldwide', value: 25, suffix: 'K+' },
  { label: 'Global Branches', value: 40, suffix: '+' },
];

export const experienceHighlights = [
  { year: '2014', title: 'The journey begins', desc: 'Founded in Milan with a promise to connect the Sri Lankan diaspora in Europe with home.' },
  { year: '2017', title: 'Sri Lanka expansion', desc: 'Opened branches across Sri Lanka — bringing our services closer to families on the island.' },
  { year: '2019', title: 'ISO 9001:2015 certified', desc: 'Recognised for our commitment to quality, safety and world-class logistics standards.' },
  { year: '2022', title: 'Beyond Italy', desc: 'Expanded into France, Romania and the United Kingdom to serve a growing European community.' },
  { year: '2025', title: '40+ global branches', desc: 'Today we operate a truly international network delivering happiness, one parcel at a time.' },
];

export const faqs = [
  { q: 'What services does Lanka Express Logistics offer?', a: 'Sea freight, air cargo, road transportation, warehousing, custom clearances, cargo insurance, UPB clearances and bonded trucks — serving businesses and families worldwide.' },
  { q: 'Does Lanka Express handle international shipments?', a: 'Yes — we specialise in international logistics with an extensive global network across 50+ countries.' },
  { q: 'What sets Lanka Express apart from other providers?', a: 'Our dedication to excellence, seamless end-to-end logistics, an experienced team and a strong presence across Europe & Sri Lanka.' },
  { q: 'Is my cargo insured during transportation?', a: 'Yes. Insured packages also include a complimentary personal accident cover of up to LKR 1 Million for your loved ones.' },
  { q: 'Can you handle specialised or project cargo?', a: 'Absolutely. We handle oversized, delicate and time-sensitive cargo with tailor-made solutions.' },
  { q: 'How can I get in touch with customer support?', a: 'Reach us via the contact form, email contact@lankaexpresslogi.com, or call +39 327 989 0838.' },
];

export const testimonials = [
  { name: 'Nayana Kumari', location: 'Colombo, Sri Lanka', text: 'Lanka Express is highly recommended for its reliability. Whenever I send goods to my daughter in Europe, I trust them to deliver promptly and securely.' },
  { name: 'Kasun Priyadarshana', location: 'Rome, Italy', text: 'Sending gifts to my family was an absolute pleasure — seamless from start to finish. The joy on my family\'s faces was priceless.' },
  { name: 'Shehan Fernando', location: 'Milan, Italy', text: 'I rely on Lanka Express for their friendly, personal service. Their insurance coverage gives me real peace of mind.' },
  { name: 'Anushka Perera', location: 'Paris, France', text: 'Fast, professional and always on time. The team consistently goes above and beyond.' },
];

export const europeBranches = [
  { name: 'Head Office', country: 'Italy', city: 'Milan', phone: '+39 327 989 0838', address: 'Via Della Republica, 49, 20090 Cesano Boscone, Lombardy', head: true, lat: 45.4433, lng: 9.0946 },
  { name: 'Milano Pasteur', country: 'Italy', city: 'Milan', phone: '+39 327 430 4884', lat: 45.4776, lng: 9.2337 },
  { name: 'Milano Zara', country: 'Italy', city: 'Milan', phone: '+39 351 902 4471', lat: 45.4954, lng: 9.1975 },
  { name: 'Milano St. Agostino', country: 'Italy', city: 'Milan', phone: '+39 324 806 8743', lat: 45.4577, lng: 9.1734 },
  { name: 'Verona Branch', country: 'Italy', city: 'Verona', phone: '+39 320 634 3988', lat: 45.4384, lng: 10.9916 },
  { name: 'Rome Branch', country: 'Italy', city: 'Rome', phone: '+39 328 533 7883', lat: 41.9028, lng: 12.4964 },
  { name: 'Napoli - Piazza Cavour', country: 'Italy', city: 'Naples', phone: '+39 388 988 8751', lat: 40.8579, lng: 14.2452 },
  { name: 'Firenze Branch', country: 'Italy', city: 'Florence', phone: '+39 351 302 6155', lat: 43.7696, lng: 11.2558 },
  { name: 'Paris Branch', country: 'France', city: 'Paris', phone: '+33 75 333 8950', lat: 48.8566, lng: 2.3522 },
  { name: 'Romania Branch (Supreme Express SRL)', country: 'Romania', city: 'Bucharest', phone: '+40 774 592 769', lat: 44.4268, lng: 26.1025 },
  { name: 'UK Branch', country: 'United Kingdom', city: 'London', phone: '+44 20 3488 7124', lat: 51.5074, lng: -0.1278 },
];

export const otherServices = [
  { name: 'Home Pick Up', region: 'Italy', desc: 'Door-to-door parcel collection across Italy \u2014 no need to visit a branch.', phone: '+39 327 073 3230', icon: 'Home' },
  { name: 'Gift Services', region: 'Europe \u2192 Sri Lanka', desc: 'Send curated gift parcels to loved ones with premium tracked delivery.', phone: '+39 338 864 8590', icon: 'Gift' },
  { name: 'Customer Service Line 1', region: 'Sri Lanka', desc: 'Primary support line for enquiries, complaints and quotes.', phone: '+94 70 361 6162', icon: 'Headphones' },
  { name: 'Customer Service Line 2', region: 'Sri Lanka', desc: 'Secondary support line \u2014 available for overflow and urgent calls.', phone: '+94 70 361 6163', icon: 'PhoneCall' },
];

export const sriLankaBranches = [
  { name: 'Seeduwa', phone: '+94 71 302 0202', lat: 7.1275, lng: 79.8720, country: 'Sri Lanka' },
  { name: 'Ja Ela', phone: '+94 70 311 6164', lat: 7.0740, lng: 79.8917, country: 'Sri Lanka' },
  { name: 'Wenappuwa', phone: '+94 70 361 6169', lat: 7.3444, lng: 79.8467, country: 'Sri Lanka' },
  { name: 'Chilaw', phone: '+94 70 361 6789', lat: 7.5758, lng: 79.7953, country: 'Sri Lanka' },
  { name: 'Negombo', phone: '+94 70 361 6099', lat: 7.2094, lng: 79.8358, country: 'Sri Lanka' },
  { name: 'Wellawattha', phone: '+94 70 661 6140', lat: 6.8783, lng: 79.8617, country: 'Sri Lanka' },
  { name: 'Panadura', phone: '+94 70 661 6141', lat: 6.7132, lng: 79.9026, country: 'Sri Lanka' },
  { name: 'Hikkaduwa', phone: '+94 70 661 6142', lat: 6.1408, lng: 80.1000, country: 'Sri Lanka' },
  { name: 'Galle', phone: '+94 70 661 6143', lat: 6.0535, lng: 80.2210, country: 'Sri Lanka' },
  { name: 'Kurunegala', phone: '+94 70 661 6157', lat: 7.4867, lng: 80.3647, country: 'Sri Lanka' },
  { name: 'Yakkala', phone: '+94 70 661 6156', lat: 7.0847, lng: 80.0272, country: 'Sri Lanka' },
  { name: 'Kandy', phone: '+94 70 661 6158', lat: 7.2906, lng: 80.6337, country: 'Sri Lanka' },
  { name: 'Kaluthara', phone: '+94 70 761 6149', lat: 6.5854, lng: 79.9607, country: 'Sri Lanka' },
  { name: 'Union Place', phone: '+94 70 761 6133', lat: 6.9271, lng: 79.8612, country: 'Sri Lanka' },
  { name: 'Peliyagoda', phone: '+94 70 761 6132', lat: 6.9689, lng: 79.8869, country: 'Sri Lanka' },
  { name: 'Anuradhapura', phone: '+94 70 707 6431', lat: 8.3114, lng: 80.4037, country: 'Sri Lanka' },
  { name: 'Puttalam', phone: '+94 70 707 6430', lat: 8.0362, lng: 79.8283, country: 'Sri Lanka' },
  { name: 'Trincomalee', phone: '+94 70 707 6432', lat: 8.5874, lng: 81.2152, country: 'Sri Lanka' },
  { name: 'Batticaloa', phone: '+94 70 707 6433', lat: 7.7100, lng: 81.7000, country: 'Sri Lanka' },
  { name: 'Jaffna', phone: '+94 70 707 6437', lat: 9.6615, lng: 80.0255, country: 'Sri Lanka' },
  { name: 'Mannar', phone: '+94 70 707 6435', lat: 8.9810, lng: 79.9044, country: 'Sri Lanka' },
  { name: 'Vavuniya', phone: '+94 70 707 6434', lat: 8.7514, lng: 80.4971, country: 'Sri Lanka' },
  { name: 'Matara', phone: '+94 70 707 6438', lat: 5.9549, lng: 80.5550, country: 'Sri Lanka' },
  { name: 'Mahawewa', phone: '+94 70 707 8310', lat: 7.3547, lng: 79.8367, country: 'Sri Lanka' },
  { name: 'Katunayake', phone: '+94 70 707 3159', lat: 7.1697, lng: 79.8843, country: 'Sri Lanka' },
  { name: 'Ambalangoda', phone: '+94 70 707 3940', lat: 6.2350, lng: 80.0538, country: 'Sri Lanka' },
];

export const partners = ['DHL', 'FedEx', 'Maersk', 'MSC', 'Emirates SkyCargo', 'Qatar Airways Cargo', 'CMA CGM', 'Kuehne+Nagel'];

export const heroImages = {
  bg: '/images/staff_containers.jpg',
  ship: '/images/staff_warehouse.jpg',
  air: '/images/staff_truck.jpg',
  sea: '/images/staff_counter.jpg',
  road: '/images/staff_truck.jpg',
  warehouse: '/images/staff_counter.jpg',
  containers: '/images/staff_containers.jpg',
  team: '/images/staff_warehouse.jpg',
  counter: '/images/staff_counter.jpg',
  truck: '/images/staff_truck.jpg',
  logo: '/brand/lanka-express-logo.png',
  logoWhite: '/brand/lanka-express-logo.png',
};
